import { useState } from "react";
import { Card } from "react-bootstrap";
import { useParams, useOutletContext } from "react-router";
import Loader from "../loader/loader";
import { LS_TYPE_FILTERS } from "../strings";
import { CustomCard } from "../common-styling";
import LeadServiceTypesFilter from "./lead-service-types-filter";
import LeadServiceInsightsBarChart from "../ls-insights-bar-chart";
import { fetchLeadServiceInsight } from "../../services/api-declaration";
import { formatLeadServiceInsightsForBarChart } from "../../services/common-service";
import { useTranslation } from "react-i18next";

const LeadServiceAnalytics = ({
  data,
  setData,
  startedAt,
  selectedLsType,
  setLsType,
  selectedVersion,
  currentDateRangeMode,
  dateRange
}) => {
  const { t } = useTranslation();
  const funnelId = useParams().id;
  const { funnelVersions } = useOutletContext();
  const [lsFilterLoader, setLsFilterLoader] = useState(false);

  const handleLsTypeChange = async ({
    selectedType = LS_TYPE_FILTERS.ALL
  } = {}) => {
    if (!funnelVersions) {
      return;
    }
    setLsFilterLoader(true);
    let _endDate = new Date(dateRange[1]?.toDateString());
    _endDate.setDate(_endDate.getDate() + 1);
    try {
      const response = await fetchLeadServiceInsight(funnelId, {
        lsType: selectedType,
        startDate: dateRange[0],
        endDate: _endDate,
        dateRangeMode: currentDateRangeMode,
        funnelVersion: funnelVersions?.currentVersion
          ? funnelVersions.currentVersion._id
          : selectedVersion._id
      });
      setData(
        formatLeadServiceInsightsForBarChart({ collection: response.data.data })
      );
    } catch (error) {
      console.error("Error in handleLsTypeChange: ", error);
    } finally {
      setLsFilterLoader(false);
    }
  };

  return (
    <CustomCard>
      <Card.Header className="bg-white kpi-tiles-header">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="mb-0 fw-bold">Lead Service 2.0 Insights</h5>
            <div className="kpi-date">( Started From: {startedAt} )</div>
          </div>
          <LeadServiceTypesFilter
            selectedLsType={selectedLsType}
            lsTypeSetter={setLsType}
            handleOnChange={(_selectedType) =>
              handleLsTypeChange({ selectedType: _selectedType })
            }
          />
        </div>
      </Card.Header>
      {lsFilterLoader ? (
        <Loader calcHeight={550} />
      ) : data.total ? (
        <LeadServiceInsightsBarChart data={data} />
      ) : (
        <h6 className="mb-0 fw-bold p-5 align-self-center">{t("noData")}</h6>
      )}
    </CustomCard>
  );
};

export default LeadServiceAnalytics;
